import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './Assets/css/style.css'   
import './Assets/css/lib.css'   
import "@fontsource/nunito-sans"; 
import { BrowserRouter } from 'react-router-dom';
const baseUrl = process.env.REACT_APP_BASE_URL || "";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
   <BrowserRouter basename={baseUrl}>
    <App />
    </BrowserRouter>
  // </React.StrictMode>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
